export default __webpack_public_path__ + "static/media/JNR logo.png.ca5f5119.png";